import { render, staticRenderFns } from "./CoverPhotoEditor.vue?vue&type=template&id=571dc68b&scoped=true&"
import script from "./CoverPhotoEditor.vue?vue&type=script&lang=js&"
export * from "./CoverPhotoEditor.vue?vue&type=script&lang=js&"
import style0 from "./CoverPhotoEditor.vue?vue&type=style&index=0&id=571dc68b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dc68b",
  null
  
)

export default component.exports